// import "flatpickr/dist/themes/airbnb.css";
import Booking from "../Units/Booking";
import { useTranslation } from "react-i18next";
import {Form, Link} from "react-router-dom"
import {format, parse} from "date-fns"
import { useState, useEffect } from "react";
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import HelmetLayout from "../../components/HelmetLayout/HelmetLayout";
import bestRate from "../../image/best-rate.png"
import ScrollAnimation from 'react-animate-on-scroll';
import appAds from "../../image/appAds.png"

function LineModal(props) {
  return (
    <>
      <Modal
       {...props}
       size="lg"
       aria-labelledby="contained-modal-title-vcenter"
       centered
       backdrop="static"
       keyboard={false}
      >
        <Modal.Header className="justify-content-end">
          <Button variant="light right" onClick={props.onHide}>
          <i class="fa-solid fa-xmark purple"></i>
        </Button>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                  <img width={"100%"} src="https://res.cloudinary.com/dtdfsaaei/image/upload/v1710388651/AzumayaWeb/img-ads_qlzhfp.jpg" alt="azumaya hotel line ads" />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default function Home({news}) {
  const { t, i18n } = useTranslation();
  const language = i18n.language
  const featureItem = t("feature.feature_item", { returnObjects: true });
  const homeNews = news.slice(0,4)
  const caption = t("caption", {returnObjects: true})
  const [isOpen, setIsOpen] = useState(false)
  const [modalShow, setModalShow] = useState(false);
  const c = t("header.title")
  const sliceContent = (item) => {
    if(language == 'en') {
      return <p style={{ textAlign: "justify" }}>{item.content.slice(0, 90)}...
      <Link 
      className="continue_link" 
      to = {`/feature/${item.id}`}
      >{t("feature.continue")}</Link></p>
    }else return <p style={{ textAlign: "justify" }}>{item.content.slice(0, 50)}...
      <Link 
      className="continue_link" 
      to = {`/feature/${item.id}`}
      >{t("feature.continue")}</Link></p>
  }
useEffect(()=>{
  if(isOpen) {
    document.body.style.position= "fixed";
  }else{
    document.body.style.position = "";
  }
})
const AutoPlaySlider =  withAutoplay(AwesomeSlider)

  return (
    <>
    <HelmetLayout title = {c} />
    <div className="homepage">
    <div className="content">
      <div className="overlay"></div>
      <AutoPlaySlider
      animation = "scaleOutAnimation"
      mobileTouch
      infinite
      play
      interval = {5000}>
            {caption?.map((item, index) => (
               <div data-src={item.image} key={index}>
                                 <Link to = {item.link}>
                                  <p className="carousel_name">{item.name}<br />{item.caption}</p>
                                  </Link>
                                  </div>
                          ))}
        </AutoPlaySlider>
      </div>
      <div className="is-sticky">
        <Booking />
      </div>
        <ScrollAnimation animateIn="fadeInUp" animateOnce>
      <div className="container">
        <div className="d-flex justify-content-center align-items-center mt-5">
              <img style={{width: '20%', height:'20%'}} src={bestRate} />
            <h2 style={{borderTop: '3px solid #89734C', borderBottom:'3px solid #89734C', paddingTop:'30px',paddingBottom:'30px'}}><Link style ={{color: '#89734C'}} to = "/feature/1">{t('home.best-link')}</Link> {t('home.best-rate')}</h2>
        </div>
      </div>
       <div className="container mt-5">
          <div className="row justify-content-center align-item-center">
              <div className="col-md-6 d-flex align-items-center justify-content-center">
                <img fetchpriority="high" style={{width: '70%', height:'100%'}} src={appAds} alt="massage" />
              </div>
              <div className="col-md-6 pre-line">
                <div className="promo-title" style={{fontSize: "2.6rem"}}>{t('home.app-title')}</div>
                <div className="promo-title" style={{fontSize: "2rem"}}>{t('home.app-sub-title')}</div>
                <p className="promo-text mt-5 pre-line" style={{fontSize: "1.8rem"}}>{t('home.app-content')}</p>
                <div className="promo-title mt-5" style={{fontSize: "2rem"}}>{t('home.app-scan')}</div>
                <div className="d-flex justify-content-center" >
                </div>
              </div>
              <img
                      className="style-line col-md-2" style={{marginTop: '50px'}}
                      src="https://azumayavietnam.com/image/logo/style-line.png"
                      alt=""
                      effect="blur"
                    />
          </div>
        </div>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeInUp" animateOnce>
        <div className="content__news">
          <div className="container">
            <div className="row align-item-center justify-content-center">
              <div className="col-md-12">
                <h2 className="content__news-title" style={{fontWeight:'bold'}}>{t("home.news_title")}</h2>
                <div className="d-flex align-item-center justify-content-md-center">
                <ul className="content__news-list">
                {homeNews?.map((article, index) => {
                 const parsedDate = parse(article.date, 'yyyy-MM-dd', new Date()); 
                 const formattedDate = format(parsedDate, 'MMM do yyyy')
                 const [all, month, day, suffix, year] = formattedDate.match(/(\w+) (\d+)(\w+) (\d+)/);
                 const encodedTitle = encodeURIComponent(article.title);
                 const modifiedTitle = encodedTitle.replace(/%20/g, '-');
                 return(
                  <div className="d-flex" key={index}>
                  <div className="mt-1 news_date-container" >
                    <div className="news_box1">
                      <div className="news_time-home">
                      <div className="month">{month}</div>
                      <div className="day pl-2">{day}</div>
                      <sub className="suffix pt-2">{suffix}</sub>
                      <div className="year pl-2">{year}</div>
                      </div>
                    </div>
                  </div>
                  <div className="news_branch-container" >
                        <div className="phnompenh phnompenh_home">{t("header.pp")}</div>
                       </div>
                       <div className="mt-2 news_title-container">
                         <div key={article.id}>
                           <Link
                             className="news_title news_homeTitle"
                             to={`/${language}/news/${modifiedTitle}`}
                           >
                             <div className="article_title">{article.news_title}</div>
                           </Link>
                         </div>
                       </div>
                     </div>
                          
                   );
                 }
               )}
                </ul>
              </div>
              </div>
            </div>
          </div>
        </div>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeInUp" animateOnce>
        <div className="content__welcome">
          <div className="container">
            <div className="row align-item-center">
              <div className="col-md-12 p-3">
                <h1 className="content__welcome-text">
                  {t("home.welcome_title")}
                  <small className="welcome_text-small">{t("home.welcome_sub-title")}</small>
                </h1>
                <p className="welcome-content">{t("home.welcome_content")}</p>
              </div>
            </div>
          </div>
        </div>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeInUp" animateOnce>
        <div className="content__feature">
          <div className="content__feature-title">{t("feature.name")}</div>
          <div style={{width: '100%'}}>
            <div className="row m-0">
              {featureItem?.map((item, index) => (
                <div className="col-md-6 col-lg-6 col-xl-3 col-xxl-3" key={index}>
                  <div className="content__feature-item">
                    <div className="content__feature-container">
                      <div
                        className="content__feature-img"
                        style={{ backgroundImage: `url(${item.image})` }}
                      >
                         <Link 
                          className="d-block"
                          style={{height: '100%'}}
                      to = {`/feature/${item.id}`}
                      ></Link>
                      </div>
                    </div>
                    <div className="content__feature-name">
                      <a href={`/feature/${item.id}`}>{item.title}</a>
                    </div>
                    <div className="content__feature-text">
                    {sliceContent(item)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </ScrollAnimation>
    </div>
    </>
  );
}
